import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@folio/stripes-components';
import css from './AuthoritySuggestions.css';

const SelectorComponent = ({
  label,
  options,
  value,
  onChange,
  id,
  className,
}) => {
  // Prevent blur only when clicking on the label, not on the select itself
  const handleLabelMouseDown = (event) => {
    event.preventDefault(); // Prevent blur on text field
  };

  return (
    <div className={className}>
      <span
        className={css.countLabel}
        onMouseDown={handleLabelMouseDown}
      >
        {label}
      </span>
      <Select
        id={id}
        dataOptions={options}
        value={value}
        onChange={onChange}
        marginBottom0
      />
    </div>
  );
};

SelectorComponent.propTypes = {
  label: PropTypes.node.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default SelectorComponent;
